import { Component, OnInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { AuthService } from '@app/core/auth.service';

import { WigAwardsSummary } from './wig-awards-summary.model';
import { WigAwardsService } from './wig-awards.service';

@Component({
  selector: 'app-wig-awards',
  templateUrl: './wig-awards.component.html',
  styleUrls: ['./wig-awards.component.css'],
})
export class WigAwardsComponent implements OnInit {
  awardsSummary: WigAwardsSummary;
  claimURL: string;
  driverCode: string;
  isLoading: boolean;

  constructor(private authService: AuthService, private wigAwardsService: WigAwardsService) {}

  ngOnInit() {
    this.driverCode = this.authService.getCurrentUser().username;
    this.loadAwardsStatus();
  }

  loadAwardsStatus() {
    const today = new Date();
    const earnedPointsStartDate = new Date(today.setMonth(today.getMonth() - 3));
    const earnedPointsEndDate = new Date(today.setMonth(today.getMonth() + 2));
    today.setMonth(today.getMonth() + 1);
    this.isLoading = true;

    this.wigAwardsService
      .getWigAwardsSummary(this.driverCode, today, earnedPointsStartDate, earnedPointsEndDate)
      .then((result) => {
        this.awardsSummary = result;

        if (this.awardsSummary) {
          this.awardsSummary.currentAward = this.awardsSummary.currentAward
            ? this.awardsSummary.currentAward.toLocaleLowerCase()
            : null;

          const lastYearAward = this.awardsSummary.levels.find(
            (f) => f.name === this.awardsSummary.lastYearAward
          );
          const lastYearPoints = lastYearAward ? lastYearAward.points : -1;
          if (this.awardsSummary.currentPoints > lastYearPoints) {
            this.awardsSummary.lastYearAward = this.awardsSummary.currentAward
              ? this.awardsSummary.currentAward.toLocaleLowerCase()
              : null;
          } else {
            this.awardsSummary.lastYearAward = this.awardsSummary.lastYearAward
              ? this.awardsSummary.lastYearAward.toLocaleLowerCase()
              : null;
          }

          if (this.awardsSummary && this.awardsSummary.earnedPoints) {
            this.awardsSummary.earnedPoints.sort(
              (val1, val2) => <any>new Date(val1.qualifyPeriod) - <any>new Date(val2.qualifyPeriod)
            );
          }

          const driverCode = this.authService.getCurrentUser().username;
          const currentAward = this.awardsSummary ? this.awardsSummary.currentAward : null;
          void this.wigAwardsService
            .enroll(driverCode, currentAward, currentAward == null)
            .then((response): void => {
              if (response && response.length > 0) {
                this.claimURL = response[0].url;
              }
            });
        }
      })
      .finally(() => (this.isLoading = false));
  }
}
